__turbopack_context__.v({
  "competenciesTitle": "competencies-module__MMIPlW__competenciesTitle",
  "sectionBackgroundColor": "competencies-module__MMIPlW__sectionBackgroundColor",
});
